import { FC } from 'react'
import Typography, {
  TVariant as TTypographyVariant,
} from 'components/Typography'
import { TIconProps } from 'icons/types'
import classNames from 'classnames'
import styles from './FeatureItem.module.scss'

type TIcon = {
  Component: FC<TIconProps>
  title: string
  color?: string
}

type TSize = 'small' | 'medium' | 'big'

type TSizeValues = {
  [key in TSize]: {
    title: TTypographyVariant
    titleBold: boolean
    text: TTypographyVariant
    value: TTypographyVariant
    icon: {
      size: number
    }
  }
}

export type TProps = {
  Icon?: TIcon
  title?: string
  text?: string
  value?: string | number
  size?: TSize
  testId?: string
  className?: string
}

const FeatureItem: FC<TProps> = ({
  Icon,
  title,
  text,
  value,
  size = 'medium',
  testId,
  className = '',
}) => {
  const sizeValues: TSizeValues = {
    small: {
      title: 'Label',
      titleBold: false,
      text: 'LabelSmall',
      value: 'Label',
      icon: {
        size: 16,
      },
    },
    medium: {
      title: 'Paragraph',
      titleBold: false,
      text: 'Label',
      value: 'Paragraph',
      icon: {
        size: 24,
      },
    },
    big: {
      title: 'ParagraphBig',
      titleBold: true,
      text: 'ParagraphSmall',
      value: 'ParagraphBig',
      icon: {
        size: 24,
      },
    },
  }

  const featureItemClasses = classNames(styles.ecFeatureItem, className)

  return (
    <div className={featureItemClasses} data-testid={testId}>
      {Icon?.Component && (
        <div
          className={classNames(styles.ecFeatureItemIconWrapper, {
            [styles.ecFeatureItemIconWrapperSmall]: size === 'small',
          })}
        >
          <Icon.Component
            title={Icon.title}
            color={Icon?.color || 'grey900'}
            width={sizeValues[size].icon.size}
            height={sizeValues[size].icon.size}
          />
        </div>
      )}
      {(title || text) && (
        <div className={styles.ecFeatureItemContent}>
          {title && (
            <Typography
              variant={sizeValues[size].title}
              bold={sizeValues[size].titleBold}
            >
              {title}
            </Typography>
          )}
          {text && (
            <Typography
              className={styles.ecFeatureItemText}
              variant={sizeValues[size].text}
            >
              {text}
            </Typography>
          )}
        </div>
      )}
      {value && (
        <Typography
          className={classNames(styles.ecFeatureItemValue, {
            [styles.ecFeatureItemValueRight]: title || text,
          })}
          variant={sizeValues[size].value}
          bold
        >
          {value}
        </Typography>
      )}
    </div>
  )
}

export default FeatureItem
